// GENERATED from messaging-platform/packages/chat-core/src/thread-scroll.ts. Do not edit here: edit there, then run scripts/sync-chat-core.cjs.
/** Scroll and loader rules for an open conversation, kept apart from the components so they can be tested on their own. */

export interface ScrollRestore {
  /** scrollHeight when the older page was asked for */
  height: number;
  /** scrollTop at that moment */
  top: number;
}

export interface RenderedView {
  /** messages drawn now */
  count: number;
  /** messages drawn at the last render */
  lastCount: number;
  /** the reader was at the bottom */
  stickToBottom: boolean;
  scrollHeight: number;
  restore: ScrollRestore | null;
  /** the older page is still on its way */
  loading: boolean;
}

/**
 * Where to put the scroll after a render. An older page keeps the reader on the message they were reading, but only
 * once its messages are drawn: renders before that (the loader appearing) must not use up the saved position.
 */
export function scrollAfterRender(v: RenderedView): { scrollTop: number | null; keepRestore: boolean } {
  const drawnNew = v.count !== v.lastCount;
  if (v.restore) {
    if (!drawnNew) return { scrollTop: null, keepRestore: v.loading };
    return { scrollTop: v.scrollHeight - v.restore.height + v.restore.top, keepRestore: false };
  }
  return { scrollTop: drawnNew && v.stickToBottom ? v.scrollHeight : null, keepRestore: false };
}

/** Which loader the conversation shows: the first page in the middle of an empty pane, older pages above the messages. */
export function threadLoader(thread: { loading: boolean; loaded: boolean; messages: unknown[] } | null): 'first' | 'older' | null {
  if (!thread) return 'first';
  if (!thread.loading) return null;
  return thread.messages.length ? 'older' : 'first';
}

/** Where the message a reply answers sits: from the messages on screen, or the position the hub sent with the reply. */
export function replyTargetSeq(
  loaded: readonly { id: string; seq: number }[],
  reply: { replyToMessageId: string | null; replyToSeq?: number },
): number | null {
  if (!reply.replyToMessageId) return null;
  return loaded.find((m) => m.id === reply.replyToMessageId)?.seq ?? reply.replyToSeq ?? null;
}
